<quill-editor #editor [modules]="QuillConfiguration" />